import { isPro } from "@/utils/index.js";
import request from "@/utils/request.js";
const TEST = "https://prehuituaccess.sparta.html5.qq.com";
const PRO = "https://huituaccess.map.qq.com";
const ENV = isPro() ? PRO : TEST;

export const drawApi = (data) =>
  request("POST", `${ENV}/ishare_score/lotteries/draw`, data);
export const duringApi = (data) =>
  request("POST", `${ENV}/ishare_score/lotteries/during`, data);
export const latestApi = (data) =>
  request("POST", `${ENV}/ishare_score/lotteries/latest`, data);
export const exchangeApi = (data) =>
  request("POST", `${ENV}/ishare_score/lotteries/exchange`, data);
export const mywinApi = (data) =>
  request("POST", `${ENV}/ishare_score/lotteries/mywin`, data);
export const getDefaultApi = (data) =>
  request("POST", `${ENV}/ishare_score/address/getDefault`, data);
